import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ErrorDataUnavailable } from '@/components/common/Error';
const CuratorVaultsTableError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorDataUnavailable minHeight="600px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(CuratorVaultsTableError);